
<ng-container *ngIf="!equipmentProviderInActive">
<div class="plain-controls" *ngIf="navigationStyle == 'plain'; else dots">
    <div class="controlLineDiv control-button" (click)="navigateTo(idx)" [ngClass]="{'control-button_active': idx == currentIndex }" *ngFor="let btn of elementsList; let idx = index"></div>
</div>
<ng-template #dots>
    <div class="dot-controls" [ngClass]="{'dots-white': dotsColor == 'white'}">
        <div class="arrow prev" id="slider-left" (click)="onNavigationPrevClick()"><img src="https://cdn.icreditworks.com/tp/assets/images/left-arrow.png'" alt="" loading="lazy">
        </div>
        <ul>
            <li class="dot" *ngFor="let i of elementsList;let idx = index" [ngClass]="idx === currentIndex ? 'active' : ''" (click)="navigateTo(idx)"></li>
        </ul>
        <div class="arrow next" id="slider-right" (click)="onNavigationNextClick()"><img src="https://cdn.icreditworks.com/tp/assets/images/right-arrow.png'" alt="" loading="lazy"></div>
    </div>
</ng-template>
</ng-container>


<ng-container *ngIf="equipmentProviderInActive">


    <span *ngIf="breakpoints.small || breakpoints.extraSmall">
        <div class="plain-controls" *ngIf="navigationStyle == 'plain' else dots">
            <div class="controlLineDiv control-button" (click)="navigateTo(idx)" [ngClass]="{'control-button_active': idx == currentIndex }" *ngFor="let btn of elementsList; let idx = index"></div>
        </div>
        <ng-template #dots>
            <div class="dot-controls" [ngClass]="{'dots-white': dotsColor == 'white'}">
                <div class="arrow prev" id="slider-left" (click)="onNavigationPrevClick()"><img src="https://cdn.icreditworks.com/tp/assets/images/left-arrow.png'" alt="" loading="lazy">
                </div>
                <ul>
                    <li class="dot" *ngFor="let i of elementsList;let idx = index" [ngClass]="idx === currentIndex ? 'active' : ''" (click)="navigateTo(idx)"></li>
                </ul>
                <div class="arrow next" id="slider-right" (click)="onNavigationNextClick()"><img src="https://cdn.icreditworks.com/tp/assets/images/right-arrow.png'" alt="" loading="lazy"></div>
            </div>
        </ng-template>
    </span>

 </ng-container>